import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { deliveryService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'deliveryPhases',
  initialState: adapter.getInitialState({
    busy: false,
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setDirty(state, action) {
      let dirty = action.payload;
      state.dirty = dirty;
    },
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchDeliveryPhasesDetails = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await deliveryService.fetchDeliveryPhasesDetails(params);
    dispatch(slice.actions.removeAll(resData));
    dispatch(slice.actions.addOne(resData));
  } catch (err) {
    dispatch(slice.actions.addOne({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
  // dispatch(slice.actions.setDirty(false));
};

const fetchDeliveryPhasesDetailsCT = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await deliveryService.fetchDeliveryPhasesDetailsCT(params);
    dispatch(slice.actions.removeAll(resData));
    dispatch(slice.actions.addOne(resData));
  } catch (err) {
    dispatch(slice.actions.addOne({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
  // dispatch(slice.actions.setDirty(false));
};

const actions = {
  ...slice.actions,
  fetchDeliveryPhasesDetails,
  fetchDeliveryPhasesDetailsCT,
};

const selectors = {
  ...adapter.getSelectors((state) => state.deliveryPhases),
};

export { actions, selectors };

export default slice.reducer;
